import React from "react";
import { EditAction, ActionButton } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

const ActionButtons = ({ id, contractId, customerId, name, mutation, history, deleteDisabled = false, intl }) => {
  const [deleteRoomTemplate] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.roomtemplate_manage]}>
        <EditAction url={`/roomTemplate/edit/${id}/contractId/${contractId}`} />
        <ActionButton icon="code" url={`/roomTemplate/file-editor/${id}/contractId/${contractId}`} />
        <DeleteActionWithModal
          disabledTooltipText={intl.formatMessage({ id: "app.roomTemplate.delete.hasEvents" })}
          disabled={deleteDisabled}
          actionButton
          urlOnSuccess={`/contract/details/${contractId}`}
          history={history}
          mutation={deleteRoomTemplate}
          mutationVariables={{ roomTemplateId: id, contractId, customerId }}
          elementNameInResult="deleteRoomTemplate"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Id del contrato
   **/
  contractId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object,
  /**
   * Indica que el botón está deshabilitado
   **/
  deleteDisabled: PropTypes.bool,
};

export default injectIntl(ActionButtons);
